(function () {
  var SIZE_SUFFIX = /_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*)$/i;

  function altFromFilename(src) {
    if (!src) return '';
    try {
      var clean = src.split('?')[0];
      var parts = clean.split('/');
      var filename = parts[parts.length - 1];
      var name = filename.replace(/\.[^/.]+$/, '');
      name = name.replace(SIZE_SUFFIX, '');
      name = name.replace(/[-_+%20]+/g, ' ').replace(/\s+/g, ' ').trim();
      if (!name) return '';
      return name.replace(/\b\p{L}/gu, function (c) { return c.toUpperCase(); });
    } catch (e) {
      return '';
    }
  }

  function processImage(img) {
    if (!img || img.tagName !== 'IMG') return;
    var current = img.getAttribute('alt');
    if (current && current.trim() !== '') {
      img.setAttribute('data-auto-alt-done', '');
      return;
    }
    var src = img.getAttribute('src') || img.getAttribute('data-src') || img.currentSrc || '';
    if (!src) return;
    var alt = altFromFilename(src);
    if (alt) {
      img.setAttribute('alt', alt);
      img.setAttribute('data-auto-alt-done', '');
    }
  }

  function processImagesIn(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.tagName === 'IMG') {
      if (!root.hasAttribute('data-auto-alt-done')) processImage(root);
      return;
    }
    if (!root.querySelectorAll) return;
    var imgs = root.querySelectorAll('img:not([data-auto-alt-done])');
    for (var i = 0; i < imgs.length; i++) processImage(imgs[i]);
  }

  function init() {
    processImagesIn(document.body);

    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) {
            processImagesIn(m.addedNodes[j]);
          }
        } else if (m.type === 'attributes' && m.target.tagName === 'IMG') {
          m.target.removeAttribute('data-auto-alt-done');
          processImage(m.target);
        }
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
